module.exports = __webpack_public_path__ + "img/hk_room_floorplan_13_en.d96a8a1b.png";